export const reactionAssets = [
  { id: "heart", label: "Amei", src: "/assets/rede-lua/reactions/1211-pepeheart.png" },
  { id: "curious", label: "Hmm…", src: "/assets/rede-lua/reactions/60369-whaat.png" },
  { id: "happy", label: "Boa!", src: "/assets/rede-lua/reactions/631592-satisfiedbob.png" },
  { id: "cool", label: "Mandou bem", src: "/assets/rede-lua/reactions/600559-glasses.png" },
  { id: "focus", label: "Foco", src: "/assets/rede-lua/reactions/68986-soldierhamster.png" },
  { id: "idea", label: "Ideia", src: "/assets/rede-lua/reactions/486800-plotting.png" },
  { id: "popcorn", label: "Assistindo", src: "/assets/rede-lua/reactions/5577_Pusheen_popcorn.png" },
  { id: "shiba", label: "Curti", src: "/assets/rede-lua/reactions/60797-shiba.png" },
];

export const interfaceAssets = {
  search: "/assets/rede-lua/icons/4322-search.png",
  upload: "/assets/rede-lua/icons/2050-upload.png",
  settings: "/assets/rede-lua/icons/6576-settings.png",
  announcement: "/assets/rede-lua/icons/1701-announcement.png",
  mediaAdd: "/assets/rede-lua/icons/7291-media-add.png",
  pinned: "/assets/rede-lua/icons/6362-pinned.png",
  staff: "/assets/rede-lua/icons/5847-staff-white.png",
  member: "/assets/rede-lua/icons/3124-member-white-black.png",
};

export const lumiAnimations = [
  { id: "calm", label: "Lumi tranquilo", video: "/assets/rede-lua/lumi/lumi-calm.mp4", poster: "/assets/rede-lua/lumi/lumi-calm.webp" },
  { id: "cheer", label: "Lumi comemorando", video: "/assets/rede-lua/lumi/lumi-cheer.mp4", poster: "/assets/rede-lua/lumi/lumi-cheer.webp" },
  { id: "curious", label: "Lumi curioso", video: "/assets/rede-lua/lumi/lumi-curious.mp4", poster: "/assets/rede-lua/lumi/lumi-curious.webp" },
  { id: "smile", label: "Lumi sorrindo", video: "/assets/rede-lua/lumi/lumi-smile.mp4", poster: "/assets/rede-lua/lumi/lumi-smile.webp" },
] as const;
